import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { nav, footer } from "@/content/translations";

export default function Footer() {
    const { lang } = useLanguage();
    const t = footer[lang];
    const n = nav[lang];

    return (
        <footer className="mt-40" data-testid="site-footer">
            <div className="tm-divider max-w-[1360px] mx-auto"></div>
            <div className="max-w-[1360px] mx-auto px-8 sm:px-16 py-20 grid grid-cols-1 md:grid-cols-3 gap-16">
                <div>
                    <div className="tm-wordmark text-xl text-[hsl(var(--tm-anthracite))]">Timemetria</div>
                    <div className="mt-3 h-px w-12 bg-[hsl(var(--tm-gold))]"></div>
                    <p className="mt-6 tm-serif text-[hsl(var(--tm-anthracite-soft))] text-lg leading-relaxed max-w-xs">
                        {t.tagline}
                    </p>
                </div>
                <div>
                    <div className="tm-label">{t.navTitle}</div>
                    <ul className="mt-6 space-y-3 text-[hsl(var(--tm-anthracite-soft))] tm-serif text-lg">
                        <li><Link to="/" className="tm-gold-link">{n.accueil}</Link></li>
                        <li><Link to="/expertise" className="tm-gold-link">{n.expertise}</Link></li>
                        <li><Link to="/a-propos" className="tm-gold-link">{n.apropos}</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="tm-label">{t.contactTitle}</div>
                    <a href="mailto:contact@timemetria.com" className="mt-6 inline-block tm-gold-link tm-serif text-lg text-[hsl(var(--tm-anthracite-soft))]">
                        contact@timemetria.com
                    </a>
                    <div className="mt-8 tm-label">{t.mentionsTitle}</div>
                    <p className="mt-3 text-sm text-[hsl(var(--tm-muted))] leading-relaxed max-w-sm">
                        {t.mentions}
                    </p>
                </div>
            </div>
            <div className="max-w-[1360px] mx-auto px-8 sm:px-16 py-6 tm-label flex flex-col sm:flex-row justify-between items-center gap-2 border-t border-[hsl(var(--tm-hairline))]">
                <span>© {new Date().getFullYear()} Timemetria — {t.rights}</span>
            </div>
        </footer>
    );
}
